fx.asset({

});